import { render, staticRenderFns } from "./RecebimentoXML.vue?vue&type=template&id=7e35f662&scoped=true"
import script from "./RecebimentoXML.vue?vue&type=script&lang=js"
export * from "./RecebimentoXML.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoXML.vue?vue&type=style&index=0&id=7e35f662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e35f662",
  null
  
)

export default component.exports